/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module modules/toggleContent
 */

import $ from 'jquery';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';

export const PLUGIN_NAME = 'toggleDropdown';
export const CLICK_EVENT = 'click';

const $html = $('html');


export const DEFAULTS = {
  scrollLock: true,
  returnFocus: '',
  trapFocusFunc: Keyboard.trapFocus.bind(Keyboard),
  releaseFocusFunc: Keyboard.releaseFocus.bind(Keyboard),
  toggleTarget: '',
};

const closeAllToggleDropdowns = () => {
  $("[toggle-body-lock='true']").toggleDropdown('toggle');
};

/**
 * Handles the height of the dropdown so it takes over the screen
 * @private
 */
function titleHeaderDropdownHeight() {
  const headerDropdown = $('#plpheader_dropdown');
  if (headerDropdown.length) {
    const docHeight = document.documentElement.clientHeight;
    const $jsPageheaderNavList = $('.js-page-header__nav-list');
    const titleHeight = $('.js-toggle-container').height();

    $jsPageheaderNavList.css({ maxHeight: (docHeight - titleHeight) });
  }
}

/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 */
const itemClickHandler = ($el, opts) => {
  const $toggleThis = $($el.attr('data-toggle-select-this'));
  const toggleTargetSelector = opts.toggleTarget || '.js-toggle-container';
  const $toggleTarget = $el.data('toggle-target') === opts.toggleTarget ? $toggleThis : $(toggleTargetSelector);
  const $toggleCloseButton = $('#toggle-dropdown-close');
  if ($el.hasClass('is-active')) {
    $toggleThis.slideUp();
    $toggleThis.removeClass('is-active');
    $el.attr('aria-expanded', 'false');
    $toggleTarget.attr('aria-modal', 'false');
    $el.removeClass('is-active');
    if ($html.hasClass('focus-active')) {
      opts.releaseFocusFunc($toggleTarget, $(opts.returnFocus));
      $toggleCloseButton.off('click', closeAllToggleDropdowns);
      $el.focus();
    }
    $el.focus();
    if (opts.scrollLock) {
      $el.attr('toggle-body-lock', '');
      enableBodyScroll($toggleThis[0]);
      $toggleThis.off('scroll.toggledropdown');
    }
  } else {
    $toggleThis.slideDown();
    $toggleThis.addClass('is-active');
    $el.attr('aria-expanded', 'true');
    $toggleTarget.attr('aria-modal', 'true');
    $el.addClass('is-active');
    if ($html.hasClass('focus-active')) {
      opts.trapFocusFunc($toggleTarget);
      $toggleCloseButton.on('click', closeAllToggleDropdowns);
    }
    if ($toggleCloseButton.length) {
      $toggleCloseButton.on('click', closeAllToggleDropdowns);
    }
    if (opts.scrollLock) {
      $el.attr('toggle-body-lock', 'true');
      $('html, body').scrollTop($('.js-toggle-container').offset().top);
      disableBodyScroll($toggleThis[0]);
    }
    $el.focus();
  }
  titleHeaderDropdownHeight();
};
/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
const applyEventHandlers = ($el, opts = {}) => {
  $el
    .on(CLICK_EVENT, () => itemClickHandler($el, opts));
};
/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
export default function toggleDropdown(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);

  applyEventHandlers($el, opts);
  return {
    toggle: () => itemClickHandler($el, opts),
  };
}

$.toggleDropdown = (options) => {
  $('<div/>').toggleDropdown(options);
};

$.toggleDropdown.close = () => {
  closeAllToggleDropdowns();
};

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, toggleDropdown);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-dropdown.js